import './editUser.scss';
import permissionsJson from 'application/detail/permissions.json';
import * as angular from 'angular';
import '!ng-cache-loader!./PermissionsList.html';
import { Permission as IrisPermission } from 'modules/shared/applicationTeam/ApplicationTeamService';
import { Contexts } from 'modules/core/ContextProcessorService';
class EditUserController {
    static $inject = ['$window', 'application', '$translate', '$scope', '$stateParams', 'AuthenticationService', 'LoadingService', 'ngToast', 'SegmentService', 'ApplicationTeamService', 'AccountService2', 'BLIP_DOMAIN_URL', 'BLIP_DOMAIN', 'ContextProcessorService', 'TenantService'];
    constructor($window, application, $translate, $scope, $stateParams, AuthenticationService, LoadingService, ngToast, SegmentService, ApplicationTeamService, AccountService2, BLIP_DOMAIN_URL, BLIP_DOMAIN, ContextProcessorService, TenantService) {
        'ngInject';
        this.$window = $window;
        this.application = application;
        this.$translate = $translate;
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.AuthenticationService = AuthenticationService;
        this.LoadingService = LoadingService;
        this.ngToast = ngToast;
        this.SegmentService = SegmentService;
        this.ApplicationTeamService = ApplicationTeamService;
        this.AccountService2 = AccountService2;
        this.BLIP_DOMAIN_URL = BLIP_DOMAIN_URL;
        this.BLIP_DOMAIN = BLIP_DOMAIN;
        this.ContextProcessorService = ContextProcessorService;
        this.TenantService = TenantService;
        this.permissions = {};
        this.permissionSelect = 'custom';
        this.localUserKey = 'LOCAL_STORAGE_UER';
        this.initWatchers();
        if (!this.$stateParams.userData) {
            this.user = this.$stateParams.newUser
                ? this.setNewUser()
                : JSON.parse(localStorage.getItem(this.localUserKey));
            localStorage.setItem(this.localUserKey, JSON.stringify(this.user));
        }
        else {
            this.user = this.$stateParams.userData;
            localStorage.setItem(this.localUserKey, JSON.stringify(this.user));
        }
        this.user.permissions = this.user.permissions.filter((p) => p.claim);
        this.handlePermissions();
    }
    initWatchers() {
        const unsavedChangesListener = (isWindowClosing, e) => {
            const message = this.$translate.instant('modules.application.detail.persistentMenu.confirmationMessage');
            this.LoadingService.stopLoading();
            if (this.permissionsForm.$dirty) {
                if (!isWindowClosing &&
                    !e.defaultPrevented &&
                    !confirm(message)) {
                    e.preventDefault();
                    return false;
                }
                e.returnValue = message;
                return message;
            }
        };
        this.$window.onbeforeunload = unsavedChangesListener.bind(this, true);
        this.$scope.$on('$stateChangeStart', unsavedChangesListener.bind(this, false));
        this.$scope.$on('$destroy', () => (window.onbeforeunload = undefined));
    }
    setSelect() {
        if (Object.keys(this.permissions).every((key) => this.permissions[key].permissionAction === 3)) {
            this.permissionSelect = 'admin';
        }
        else if (Object.keys(this.permissions).every((key) => key !== 'team'
            ? this.permissions[key].permissionAction === 0
            : true)) {
            this.permissionSelect = 'none';
        }
        else if (Object.keys(this.permissions).every((key) => key !== 'team'
            ? this.permissions[key].permissionAction === 1
            : true)) {
            this.permissionSelect = 'read';
        }
        else if (Object.keys(this.permissions).every((key) => key !== 'team'
            ? this.permissions[key].permissionAction === 3
            : true)) {
            this.permissionSelect = 'readWrite';
        }
        else {
            this.permissionSelect = 'custom';
        }
    }
    checkSelect() {
        if (this.permissionSelect === 'admin') {
            const result = Object.keys(this.permissions).every((key) => this.permissions[key].permissionAction === 3);
            if (result) {
                return 'admin';
            }
            else {
                const team = 'team';
                this.permissions[team].permissionAction = 0;
                return 'custom';
            }
        }
        else if (this.permissionSelect === 'none' ||
            this.permissionSelect === 'read' ||
            this.permissionSelect === 'readWrite') {
            switch (this.permissionSelect) {
                case 'none':
                    return Object.keys(this.permissions).every((key) => key !== 'team'
                        ? this.permissions[key].permissionAction == 0
                        : true)
                        ? 'none'
                        : 'custom';
                case 'read':
                    return Object.keys(this.permissions).every((key) => key !== 'team'
                        ? this.permissions[key].permissionAction == 1
                        : true)
                        ? 'read'
                        : 'custom';
                case 'readWrite':
                    return Object.keys(this.permissions).every((key) => key !== 'team'
                        ? this.permissions[key].permissionAction == 3
                        : true)
                        ? 'readWrite'
                        : 'custom';
            }
        }
        else {
            const key = Object.keys(this.permissions)[0];
            const isSame = Object.keys(this.permissions).every((k) => k !== 'team'
                ? this.permissions[k].permissionAction ==
                    this.permissions[key].permissionAction
                : true);
            if (isSame) {
                return this.permissions[key].permissionAction == 0
                    ? 'none'
                    : this.permissions[key].permissionAction == 1
                        ? 'read'
                        : this.permissions[key].permissionAction == 3
                            ? 'readWrite'
                            : 'custom';
            }
            else {
                return 'custom';
            }
        }
    }
    checkStatus() {
        if (this.permissionSelect === 'admin' &&
            Object.keys(this.permissions).every((key) => this.permissions[key].permissionAction == 3)) {
            return;
        }
        this.permissionsForm.$setDirty();
        this.permissionSelect = this.checkSelect();
    }
    setGroups(permission, groups) {
        if (permission.claim === 102 ||
            permission.claim === 103 ||
            permission.claim === 104 ||
            permission.claim === 117) {
            const ia = groups.find((g) => g.key === 'ia');
            if (ia) {
                ia.permissions = [...ia.permissions, permission];
            }
            return [...groups, ia];
        }
        else if (permission.claim === 109 || permission.claim === 110) {
            const configurations = groups.find((g) => g.key === 'configurations');
            configurations.permissions = [
                ...configurations.permissions,
                permission,
            ];
            return [...groups, configurations];
        }
        else {
            return [...groups, permission];
        }
    }
    selectAllPermissions() {
        this.permissionsForm.$setDirty();
        switch (this.permissionSelect) {
            case 'none':
                this.selectAll(0);
                break;
            case 'read':
                this.selectAll(1);
                break;
            case 'readWrite':
                this.selectAll(3);
                break;
            case 'admin':
                this.selectAll(4);
                break;
            default:
                const key = 'team';
                this.permissions[key].permissionAction = 0;
                break;
        }
    }
    selectAll(code) {
        if (code === 4) {
            code = 3;
            Object.keys(this.permissions).map((key) => {
                const permission = this.permissions[key];
                if (key !== 'team') {
                    permission.permissionAction = code;
                    return permission;
                }
                else {
                    permission.permissionAction = code;
                    return permission;
                }
            });
        }
        else {
            Object.keys(this.permissions).map((key) => {
                const permission = this.permissions[key];
                if (key !== 'team') {
                    permission.permissionAction = code;
                    return permission;
                }
                else {
                    permission.permissionAction = 0;
                    return permission;
                }
            });
        }
    }
    async handlePermissions() {
        this.permissions = Object.keys(this.user.permissions).reduce((acc, key) => {
            const p = this.user.permissions[key];
            let nameKey = p.title.split('.');
            nameKey = nameKey[nameKey.length - 2];
            if (nameKey === 'resources') {
                p.title = 'contents.title';
            }
            return { ...acc, [nameKey]: { ...p } };
        }, {});
        this.permissions = this.filterByTemplate();
        this.setSelect();
    }
    filterByTemplate() {
        switch (this.application.template) {
            case 'operator':
                return Object.keys(this.permissions).reduce((acc, key) => {
                    const p = this.permissions[key];
                    if (!(p.claim === 102 ||
                        p.claim === 103 ||
                        p.claim === 104 ||
                        p.claim === 117 ||
                        p.claim === 111 ||
                        p.claim === 114)) {
                        return { ...acc, [key]: p };
                    }
                    else {
                        return acc;
                    }
                }, {});
            case 'faq':
            case 'faq2':
            case 'master':
                return Object.keys(this.permissions).reduce((acc, key) => {
                    const p = this.permissions[key];
                    if (!(p.claim === 114 || p.claim === 106)) {
                        return { ...acc, [key]: p };
                    }
                    else {
                        return acc;
                    }
                }, {});
            case 'webhook':
            default:
                return this.permissions;
        }
    }
    async save() {
        try {
            this.LoadingService.startLoading();
            const oldPermissions = this.user.permissions;
            this.user.permissions = Object.keys(this.permissions).map((key) => this.permissions[key]);
            this.user.permissions = this.user.permissions.map((p) => {
                const isEnabled = p.permissionAction > 0 ? true : false;
                return { ...p, enabled: isEnabled };
            });
            localStorage.setItem(this.localUserKey, JSON.stringify(this.user));
            const loggedUser = this.AuthenticationService.getAccount();
            const newUser = {
                shortName: this.application.shortName,
                applicationName: this.application.name,
                userEmail: this.user.email,
                userFullName: this.user.email,
                userCulture: loggedUser && loggedUser.culture,
                returnUrl: `${this.BLIP_DOMAIN_URL}application/detail/${this.application.shortName}/home`,
                permissions: Object.keys(this.user.permissions).map((p) => ({
                    permissionClaim: this.user.permissions[p].claim,
                    permissionAction: this.user.permissions[p].permissionAction,
                    id: this.user.permissions[p].id,
                })),
            };
            const userIdentity = `${encodeURIComponent(newUser.userEmail)}@${this.BLIP_DOMAIN}`;
            if (!await this.TenantService.isEmailOnTenant(userIdentity)) {
                try {
                    const emails = [newUser.userEmail];
                    await this.TenantService.inviteMany(emails, this.ContextProcessorService.tenant.id, this.TenantService.guest);
                }
                catch (error) {
                    console.error(error);
                }
            }
            const tenantId = this.ContextProcessorService.context === Contexts.Tenants
                ? this.ContextProcessorService.tenant.id
                : undefined;
            await this.ApplicationTeamService.getOrCreateApplicationUser(this.application.shortName, newUser.userEmail, tenantId); // We only need to check if the user exists, so we won't use the User returned by the function.
            const identityUser = `${encodeURIComponent(this.user.email)}@${this.BLIP_DOMAIN}`;
            const changedIrisPermissions = this.user.permissions.map(p => IrisPermission.fromMessagingHubPermission(p, identityUser));
            this.ApplicationTeamService.setApplicationPermissions(this.application.shortName, changedIrisPermissions);
            const successMsg34 = await this.$translate('utils.successMsg.34');
            this.ngToast.success(successMsg34);
            this.SegmentService.createTrack('invite-member', {
                botName: this.application.name,
                user: this.user.email,
            });
        }
        catch (error) {
            console.error(error);
        }
        finally {
            this.permissionsForm.$setPristine();
            this.LoadingService.stopLoading();
        }
    }
    setNewUser() {
        localStorage.removeItem(this.localUserKey);
        const permissionsFile = angular.copy(permissionsJson);
        const defaultPermissions = Object.keys(permissionsFile)
            .filter(p => p && !permissionsFile[p].hideInTemplate || !permissionsFile[p].hideInTemplate.includes(this.application.template))
            .map((p) => ({
            ...permissionsFile[p],
            permissionAction: 0,
        }));
        setTimeout(() => this.permissionsForm.$setDirty(), 1000);
        const identityUser = `${encodeURIComponent(this.$stateParams.newUser.email)}@${this.BLIP_DOMAIN}`;
        const irisPermissions = defaultPermissions.map(p => IrisPermission.fromMessagingHubPermission(p, identityUser));
        return {
            permissions: defaultPermissions,
            irisPermissions,
            created: new Date(),
            isPending: true,
            fullName: this.$stateParams.newUser.email,
            ...this.$stateParams.newUser,
        };
    }
}
EditUserController.$inject = ['$window', 'application', '$translate', '$scope', '$stateParams', 'AuthenticationService', 'LoadingService', 'ngToast', 'SegmentService', 'ApplicationTeamService', 'AccountService2', 'BLIP_DOMAIN_URL', 'BLIP_DOMAIN', 'ContextProcessorService', 'TenantService'];
export default EditUserController;
